import {
  GENERATE_SUMMARY,
  GENERATE_SUMMARY_FAILURE,
  GENERATE_SUMMARY_SUCCESS,
  GET_SUMMARIES,
  GET_SUMMARY_FAILURE,
  SET_SUMMARIES,
  RESET_ERROR,
} from "./actionTypes";

export const generateSummary = ({ conversationId, messageId }) => {
  return {
    type: GENERATE_SUMMARY,
    payload: { messageId, conversationId },
  };
};

export const generateSummarySuccess = () => {
  return {
    type: GENERATE_SUMMARY_SUCCESS,
  };
};

export const generateSummaryFailure = (error) => {
  return {
    type: GENERATE_SUMMARY_FAILURE,
    payload: { error },
  };
};
export const getSummaryFailure = (error) => {
  return {
    type: GET_SUMMARY_FAILURE,
    payload: { error },
  };
};
export const getSummaries = (conversationId) => {
  return {
    type: GET_SUMMARIES,
    payload: { conversationId },
  };
};
export const setSummaries = (data) => {
    return {
      type: SET_SUMMARIES,
      payload: { ...data },
    };
  };
 
  export const resetError = () => {
    return {
      type: RESET_ERROR,
      payload: {},
    };
  };